// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1h08o","header":"ReportDetails_header__1JORI","title":"ReportDetails_title__28-gq","left":"ReportDetails_left__1x2H0"};